import { h } from 'preact';
import dlv from 'dlv';
import { Text } from 'preact-i18n';

import style from './style';
import pageStyles from '../../pageStyles';

import SimpleGridCluster from '../../../clusters/simple-grid-cluster';

import { TopBorder } from '../../../pieces/top-border';
import { SadlibAd } from '../../../pieces/sadlib-ad';
import { TaboolaJs } from '../../../pieces/taboola-js';

import { Header, Footer } from '../../shared/desktop';

import { getCommonProps } from '../../../../lib/page';
import { getIframeStyles, getRelatedProps } from '../../../../lib/game';

import { ColumnSticky, Column, Row, Section, ContainerFluid } from '@cube/layout';

export const Desktop = ({ pageConfig, article, error, ...props }) =>
	(
		<ContainerFluid class={pageStyles.fluidPageNoPadding}>
			<Header
				pageConfig={pageConfig}
				adId="sc_game_header_banner"
				{...props}
			/>
			<Section containerClass={pageStyles.defaultPageWidth}>
				<Row class={style.contentRow} key="contentRow">
					<Column class={pageStyles.contentWithSmallFixedRightColumn}>
						{ !error ?
							( article &&
								<div>
									<iframe
										src={dlv(article, 'embeds.0.content')}
										style={getIframeStyles(dlv(article, 'embeds.0'))}
										class={style.iframe}
										scrolling="no"
										allowfullscreen="true"
										mozallowfullscreen="true"
										webkitallowfullscreen="true"
									/>
									<div class={style.details}>
										<div class={style.title}>
											{article.title}
										</div>
										<div class={style.summary}>
											{article.summary}
										</div>
									</div>
								</div>
							)
							:
							<Column>
								<div class={style.noGameError}>
									<div class={style.content}>
										<div class={style.message}>
											<Text id="gameNotAvailable" />
										</div>
										<img src="https://vam-image.imds-cdn.com/7b/cb/7bcb6df2e3f7d2dc442edcca97852399b55b1950" />
									</div>
								</div>
							</Column>
						}
						<TopBorder theme="gray" />
						{ (article || error) &&
							<SimpleGridCluster
								{...getRelatedProps(article)}
								qeId="sc-game-related"
								{...getCommonProps(props)}
							/>
						}
						<TopBorder theme="gray" />
						<TaboolaJs {...dlv(pageConfig, 'taboola.belowText')} qeId="sc-game-taboola" />
					</Column>
					<ColumnSticky class={pageStyles.smallFixedRightColumn}>
						<SadlibAd id="sc_game_sidebar_top" type="desktopRail" />
						<TopBorder theme="gray" />
						<TaboolaJs {...dlv(pageConfig, 'taboola.rightRail')} qeId="sc-game-youmayalsolike" />
						<SadlibAd id="sc_game_sidebar_bottom" type="desktopRail" />
					</ColumnSticky>
				</Row>
			</Section>
			<Footer
				pageConfig={pageConfig}
				{...getCommonProps(props)}
			/>
		</ContainerFluid>
	);
